import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {UserService} from '../../services/user.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';

@Component({
  selector: 'app-set-new-email',
  templateUrl: './set-new-email.component.html',
  styleUrls: ['./set-new-email.component.css'],
  providers: [UserService]
})
export class SetNewEmailComponent implements OnInit {
  form: FormGroup;
  statusClass: string;
  mensaje: string;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private fb: FormBuilder,
  ) {
    this.statusClass = 'bg-secondary';
    this.mensaje = 'Verificando código de seguridad';
    this.form = this.fb.group({
      code: ['', [Validators.required]]
    });
   }

  ngOnInit() {
    this.getParams();
  }

  getParams() {
    this.route.params.subscribe(params => {
      if(params.changeCode){
        this.statusClass = 'bg-dark';
        this.mensaje = 'Actualizando correo electrónico';
        this.form.get('code').setValue(params.changeCode);
        this.proccesChange();
      }else{
        this.statusClass = 'bg-danger';
        this.mensaje = 'El código de seguridad para cambiar el correo no es válido, por favor ingrese desde el enlace en su correo';
      }
    });
  }

  openAlert(title, text, action, color, direccion = null): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action,
        color
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (direccion === null) {
        console.log(result);
      } else {
        this.router.navigate([direccion]);
      }
    });

   }

   proccesChange() {
    this.userService.autoriceEmailChange(this.form.value).subscribe(response => {
      if(response.status){
        this.statusClass = 'bg-success';
        this.mensaje = response.message;
      }else{
        this.statusClass = 'bg-danger';
        this.mensaje = response.message;
      }
    }, error => {
      this.statusClass = 'bg-danger';
      this.mensaje = 'No se puede procesar su petición en este momento';
      console.log(error);
      this.openAlert('Atención', 'No se puede procesar su petición en este momento', 'Cerrar', 'warn');
    });
  }

}
